export default __webpack_public_path__ + "static/media/ci.6fb775f0.svg";